export default __webpack_public_path__ + "static/media/group-off-track-woman-youth.8e6e5dd1.jpg";